"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Batch = void 0;
const tree_dump_1 = require("tree-dump");
const clock_1 = require("../clock");
class Batch {
    constructor(patches) {
        this.patches = patches;
        this.meta = undefined;
    }
    getId() {
        if (!this.patches.length)
            return undefined;
        return this.patches[0].getId();
    }
    rebase(serverTime) {
        const id = this.getId();
        if (!id)
            throw new Error('BATCH_EMPTY');
        const transformHorizon = id.time;
        const patches = this.patches;
        const length = patches.length;
        const newPatches = [];
        for (let i = 0; i < length; i++) {
            const patch = patches[i];
            newPatches.push(patch.rebase(serverTime, transformHorizon));
            serverTime += patch.span();
        }
        return new Batch(newPatches);
    }
    clone() {
        return new Batch(this.patches.map((patch) => patch.clone()));
    }
    toString(tab = '') {
        const id = this.getId();
        const header = `Batch ${id ? (0, clock_1.printTs)(id) : '(nil)'}`;
        return (header +
            (0, tree_dump_1.printTree)(tab, this.patches.map((patch) => (tab) => patch.toString(tab))));
    }
}
exports.Batch = Batch;
